import { excludeNullOrUndefined } from 'checkout/utils'
import { createSelector } from 'reselect'
import { checkoutAccommodationOfferView } from './accommodation'
import { getFlightItemsView } from './flights'
import { matchPath } from 'react-router'
import getExperienceItemsView from './getExperienceItemsView'
import { isPaymentScheduleSelected, isDepositSelected, isReserveForFreeSelected } from '../payment/paymentType'
import { selectIsHeldFlightReservationReused } from 'businessTraveller/selectors/selectHeldFlightReservation'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const isSingleDesignation = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (state: App.State) => getExperienceItemsView(state),
  (state: App.State) => getFlightItemsView(state),
  (checkoutAccommodationOfferView, getExperienceItemsView, getFlightItemsView): boolean => {
    const allItemsViews = [...checkoutAccommodationOfferView.data, ...getExperienceItemsView.data, ...getFlightItemsView.data]
    return [...new Set(allItemsViews.map(view => view?.designation).filter(excludeNullOrUndefined))].length === 1
  },
)

export const isUsingCredit = (state: App.State) => state.checkout.payment.useCredit
export const isUsingGiftCard = createSelector(
  (state: App.State) => state.checkout.payment.useGiftCard,
  (state: App.State) => isPaymentScheduleSelected(state),
  (state: App.State) => isDepositSelected(state),
  (state: App.State) => isReserveForFreeSelected(state),
  (state: App.State) => state.checkout.payment.partnerships.velocity?.burn?.isApplied,
  (useGiftCard, isPaymentScheduleSelected, isDepositSelected, isReserveForFreeSelected, isVelocityApplied) => useGiftCard && !isPaymentScheduleSelected && !isDepositSelected && !isReserveForFreeSelected && !isVelocityApplied,
)

export const selectShowPriceChanges = createSelector(
  (state: App.State) => state.checkout.cart.restoredCartDetails?.originalTotal,
  (state: App.State) => state.router.location.pathname,
  (state: App.State) => selectIsHeldFlightReservationReused(state),
  (state: App.State) => state.checkout.cart.approvalRequestId,
  (state: App.State) => state.businessTraveller.approvalRequests?.status,
  (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.lebtFlightBookAndHold),
  (hasOriginalTotal, path, isHeldFareReused, approvalRequestId, approvalRequestsStatus, isBookAndHoldEnabled): boolean => {
    // A reused held fare's price is locked, so this banner is always misleading here.
    if (isHeldFareReused) {
      return false
    }
    // The reuse loads asynchronously, so suppress while it's still loading (unfetched or pending) to avoid a
    // flash before it settles. 'failed' falls through to master so a fetch error doesn't kill the banner.
    if (isBookAndHoldEnabled && approvalRequestId && approvalRequestsStatus !== 'success' && approvalRequestsStatus !== 'failed') {
      return false
    }
    return !!(hasOriginalTotal && matchPath(path, { path: '/:regionCode/checkout/:cartId/purchase', exact: true }))
  },
)
